<template>
  <el-dialog class="import_model_dialog" top="5vh" center title="批量创建任务" width="80%" :before-close="handleClose"
             :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <el-form-item label="开发任务" :label-width="formLabelWidth">
        <div style="display: flex;">
          <el-upload
              class="upload-demo" ref="uploadDev" accept=".xls,.xlsx"
              action=""
              :on-change="uploadDevTask"
              :show-file-list="false"
              :auto-upload="false"
          >
            <el-button slot="trigger" size="mini" type="primary">导入开发任务</el-button>
          </el-upload>
          <div slot="tip" class="el-upload__tip">（请先下载开发任务模板文件，<span @click.stop="downloadFile(1)" class="down-xsl">点击下载模板</span>）</div>

        </div>
      </el-form-item>
      <el-form-item label=""  :label-width="formLabelWidth">
        <el-table :data="tasks" border style="width: 100%; margin-top: -10px;"  height="30vh" stripe :cell-style="getRowClass" :header-cell-style="getCellClass">
          <el-table-column fixed prop="id" align="center" label="ID" width="60">
          </el-table-column>
          <el-table-column prop="name" align="center" label="标题" min-width="160" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="taskContent" align="center" label="任务内容" min-width="160" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="dataLevel" align="center" label="数据量级要求" width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="responseTime" align="center" label="响应时间要求" width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="concurrency" align="center" label="并发量要求" width="100" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="technicalDifficulty" align="center" label="技术难度" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="domain" align="center" label="主域名" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="module" align="center" label="涉及系统" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="developerId" align="center" label="开发人员" width="120" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span> {{ scope.row.developerId &&  allUserList.DEVUSER &&
              allUserList.DEVUSER[scope.row.developerId] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="estimateWorkHour" align="center" label="预计工时" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="planFinishDate" align="center" label="计划完成日期" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="120">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-between;">
                <el-tooltip class="item" effect="dark" content="复制" placement="top">
                  <div class="el-icon-copy-document" style="font-size: 20px;cursor: pointer;" @click="copyTask(scope.row)"></div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                  <div class="el-icon-edit" style="font-size: 20px;cursor: pointer;" @click="editTask(scope.row)"></div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="新增" placement="top">
                  <div class="el-icon-circle-plus-outline" style="font-size: 20px;cursor: pointer;" @click="addTask()"></div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
                  <div class="el-icon-remove-outline" style="font-size: 20px;cursor: pointer;" @click="deleteTask(scope.row)"></div>
                </el-tooltip>
              </div>
<!--              <el-button  @click="linkToModel(scope.row, 'task',1)" type="primary" size="small">编辑
                            </el-button>-->
<!--              <el-button :disabled="!((scope.row.status === 0 || scope.row.status === 1) && isReviewer)"  :loading="loading['task' + scope.row.taskId]" @click="onDeleteTask(scope.row)" type="danger" size="small">删除
              </el-button>
              <el-button :disabled="!isReviewer" @click="onAddTask('copy', scope.row)" type="warning" size="small">复制
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="测试任务"  :label-width="formLabelWidth">
        <div style="display: flex;">
        <el-upload
            class="upload" ref="uploadTest" accept=".xls,.xlsx"
            action=""
            :on-change="uploadTestTask"
            :show-file-list="false"
            :auto-upload="false"
        >
          <el-button slot="trigger" size="mini" type="primary">导入测试任务</el-button>
        </el-upload>
          <div slot="tip" class="el-upload__tip">（请先下载测试任务模板文件，<span @click.stop="downloadFile(2)" class="down-xsl">点击下载模板</span>）</div>
        </div>
      </el-form-item>
      <el-form-item label=""  :label-width="formLabelWidth">
        <el-table :data="testTasks" border style="width: 100%; margin-top: -10px;"  height="25vh" stripe :cell-style="getRowClass" :header-cell-style="getCellClass">
          <el-table-column prop="id" fixed label="ID" width="60" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="name" label="标题" min-width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="id" label="关联任务状态" min-width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.taskLists && scope.row.taskLists.length > 0 " style="color: green;cursor: pointer;" @click="showChoosTask(scope.row)">已关联</span>
              <span v-else style="color:red;cursor: pointer;" @click="showChoosTask(scope.row)">未关联</span>
            </template>
          </el-table-column>
          <el-table-column prop="taskDetail" label="任务内容" min-width="180" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="testerId" label="测试人员" width="80" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                <span> {{ scope.row.testerId &&  allUserList.DEVUSER &&
                allUserList.DEVUSER[scope.row.testerId] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="estimateWorkHour" label="预估工时" width="80" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="planFinishDate" align="center" label="计划完成日期" width="120" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column fixed="right" align="center" label="操作" width="160">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: space-between;">
                <el-tooltip class="item" effect="dark" content="复制" placement="top">
              <div class="el-icon-copy-document" style="font-size: 20px;cursor: pointer;" @click="copyTestTask(scope.row)"></div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="关联任务" placement="top">
                  <div class="el-icon-connection" style="font-size: 20px;cursor: pointer;" @click="showChoosTask(scope.row)"></div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                  <div class="el-icon-edit" style="font-size: 20px;cursor: pointer;" @click="editTestTask(scope.row)"></div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="新增" placement="top">
              <div class="el-icon-circle-plus-outline" style="font-size: 20px;cursor: pointer;" @click="addTestTask(scope.row)"></div>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <div class="el-icon-remove-outline" style="font-size: 20px;cursor: pointer;" @click="deleteTestTask(scope.row)"></div>
                </el-tooltip>
              </div>
<!--              <el-button  @click="onAddTestTask('add',scope.row)" type="primary" size="small">编辑
              </el-button>-->
<!--              <el-button :disabled="!((scope.row.test_status === 0) && isReviewer)"  :loading="loading['test' + scope.row.id]" @click="onDeleteTestTask(scope.row)" type="danger" size="small">删除
              </el-button>
              <el-button :disabled="!isReviewer" @click="onAddTestTask('copy', scope.row)" type="warning" size="small">复制
              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="warning" :loading="loading.submit" @click="onSubmit">提 交</el-button>
      <el-button type="success" @click="handleClose">取 消</el-button>
    </div>
    <createTask v-if="dialogVisibleCreateTask" :dialogVisible='dialogVisibleCreateTask' :hideDialogVisible="handleCreateTaskClose" :formInfo="formTaskInfo" @changeTask="changeTask"></createTask>
    <createTestTask v-if="dialogVisibleCreateTestTask" :dialogVisible='dialogVisibleCreateTestTask' :hideDialogVisible="handleCreateTestTaskClose" :formInfo="formTestTaskInfo" @changeTestTask="changeTestTask"></createTestTask>
    <chooseTask v-if="dialogVisibleChooseTask" :dialogVisible='dialogVisibleChooseTask' :hideDialogVisible="handleChooseTaskClose" :taskList="showtasks" :checkedTestInfo="checkedTestInfo" :getChooseTask="getChooseTask" @changeChoose="changeChoose"></chooseTask>
  </el-dialog>
</template>
<script>
import xlsx from 'xlsx'
import { Editor } from "@/components/index.js";
import Task from './task.vue'
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import { formatEnToUtf8 } from "@/views/tops/devOps/components/util.js"
import  MeetList from "./meeting/list.vue";
import AddMeet from "./meeting/addMeet.vue";
import TestTask from './testTask.vue';
import {TaskHistory} from "@/views/tops/devOps/components/list";
import axios from 'axios';
import {
  getDevOpsSpaceProducerListApi,
  postDevOpsSpaceDeleteTaskApi,
  postDevOpsSpaceUserPmEditStatusApi,
  postDevOpsSpaceCreateDemandApi,
  getDevOpsSpaceFindOneDemandApi,
  postDevOpsSpaceEditDemandApi,
  getDevOpsSpaceFindProjectNameApi,
  postDevOpsSpaceSubmitDemandApi,
  getDevOpsSpaceMeetListApi,
  getDevOpsSpaceDemandTestTaskApi,
  getDevOpsSpaceHistoryTaskListApi,
  getDevOpsSpaceReportTaskListApi,
  postDevOpsSpaceDeleteTestTaskApi,
  getDevOpsSpaceDemandSkipApi,
  postDevOpsSpaceUpdatePlanDateApi,
  postDevOpsSpaceBatchCreateTaskApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {getDevOpsSpaceAllUserListApi} from "@/server/tops/base";
import ApplyRelease  from "@/views/tops/devOps/producerSpace/components/applyRelease.vue";
import createTask from "@/views/tops/devOps/producerSpace/components/import/createTask.vue";
import createTestTask from "@/views/tops/devOps/producerSpace/components/import/createTestTask.vue";
import chooseTask from "@/views/tops/devOps/producerSpace/components/import/chooseTask.vue";
import {getStorage} from "@/common/utils/storage";
export default {
  components: {TaskHistory, Editor, Comment, Task, MeetList, AddMeet, TestTask, ApplyRelease, createTask, createTestTask, chooseTask},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
  },
  data() {
    return {
      meetList:[],
      historylist: [],
      form: {
        priority: 'P1',
        reviewer: {},
        re_details:'',
        demandDesc: '',
        reviewerId: '',
        progressRate: '',
        name:'',
        pmId: '',
      },
      pStatusForm:{
        isRestart: false,
        isRollBack: false,
        status:'',
        changeReason:'',
        back_status:false,
        id:''
      },
      pUatForm:{
        uatStatus:'',
        uatDetail:'',
      },
      proForm:{
        proStatus:'',
        proDetail:'',
      },
      pSkipForm:{
        skipReason:'',
      },
      updateTimeForm:{
        planFinishDate:'',
        update_date_reason:'',
      },
      reviewerForm:{
        reviewer:'',
        loading:false
      },
      pStatusRules:{
        status:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        changeReason:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pUatRules:{
        uatStatus:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        uatDetail:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      proRules:{
        proStatus:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        proDetail:{
          required: true,
          message: "必填",
          trigger: "blur",
        }
      },
      pSkipRules:{
        skipReason:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      updateTimeRules:{
        update_date_reason:{
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate:{
          // required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      chainingLink: true,
      chainingLinkTo: true,
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false,
        submitConfirmReviewer: false,
        submitDemand: false,
        submitReset: false,
        submitUat: false,
        submitApply: false,
        submitCancel: false,
        submitComplete: false,
        skipRelease: false,
        updateTimeLoad: false,
      },
      tasks: [],
      testTasks: [],
      showtasks:[],
      dialogVisibleTask: false,
      dialogVisibleTestTask: false,
      dialogVisiblePStatus:false,
      dialogVisiblePUat: false,
      dialogVisibleReviwer: false,
      dialogVisibleMeet: false,
      dialogVisiblePro: false,
      dialogVisibleSkip: false,
      dialogVisibleUpdatePlanTime: false,
      step: 1,
      formTaskInfo: {},
      formTestTaskInfo: {},
      reviewerSelect: [],
      showDetails: false,
      // 判断是否是产品
      isUserPm:false,
      projectList: [],
      dialogVisibleApplyRelease: false,
      UATSTATUS:['失败','成功'],
      userId:'',
      username: '',
      record: false,
      updateText:[],
      recordList:[],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() <= Date.now() - 60 * 60 * 24 * 1000;
        }
      },
      allDevUser:{
        UserEn:[],
        UserIds:[],
      },
      dialogVisibleCreateTask: false,
      dialogVisibleCreateTestTask: false,
      dialogVisibleChooseTask: false,
      addData:{},
      checkedTestInfo:{},
    };
  },
  async mounted() {
    //全部人员
    await this.$store.dispatch('getDevopsUserList',{userType:''})
    const { id = '', status = '',  name = '', next = false } = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const userId = this.$store.state.devOps.userInfo.userId? this.$store.state.devOps.userInfo.userId : '';
    this.form = { ...this.form, id, status, name}
    this.$set(this.form, 'username', username)
    this.username = username;
      if(userId){
      this.form.pmId = userId.toString();
      this.userId = userId.toString();
      this.step = 2;
      this.$set(this.form, 'user_pm', username)
    }

    //获取未开始，进行中的项目
    this.$nextTick(async () => {
      //await this.getDevUserList();
      //await this.getProjectList();
    })
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
    //获取阶段
    getStage(){
      //需求讨论
      if(this.form.status === 0 || this.form.status === 1){
        return '1';
      }
      //需求评审
      if(this.form.status === 2 || this.form.status === 3){
        return '2'
      }
      //技术评审
      if(this.form.status === 4 || this.form.status === 5) {
        return '3';
      }
    },
    // 判断需求状态
    isPStatus() {
      const { status } = this.form;
      if( status === 13 || status === 14) return false;
      return true
    },
    //
    isChangetatus() {
      return this.form.status === 13 || this.form.status === 14 || this.form.status === 9 || this.form.status === 10 || this.form.status === 11 || this.form.status === 12;
    },
    // 判断是否是技术负责人
    isReviewer() {
      if(this.isAdmin || this.isReviewerLeader) return true;
      return this.form.reviewer.nameEn === this.form.username;
    },
    //判断技术负责人可以编写
    isReviewerEdit(){
      if(this.isReviewer){
        return this.form.status === 4 || this.form.status === 5;
      }
      return false;
    },
    // 判断是否是创建人
    isCreateUser(){
      if(this.form.creator){
        return this.form.creator.nameEn === this.form.username;
      }
      return false;
    },
    // 判断是否是产品
    isPm(){
      if(this.isAdmin || this.isPmLeader) return true;
      if(this.form.pm){
        return this.form.pm.nameEn === this.form.username;
      }
      return false;
    },
    isAddMeet(){

      return (this.isPm && (this.form.status === 0 || this.form.status === 1 || this.form.status === 2 || this.form.status === 3)) || (this.isReviewer &&(this.form.status === 4 || this.form.status === 5));

    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isPmLeader(){
      if(this.userId && this.form.pm){
        const pmId = this.form.pm.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[pmId]){
          return this.allUserList.LEADERUSER[pmId] === this.userId;
        }
      }
      return false;
    },
    isReviewerLeader(){
      if(this.userId && this.form.reviewer){
        const reviewerId = this.form.reviewer.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[reviewerId]){
          return this.allUserList.LEADERUSER[reviewerId] === this.userId ;
        }
      }
      return false;
    },
    //提交技术评审
    isSubmitReviewer(){
      return this.form.status === 2 || this.form.status === 3;
    },
    //提交需求评审
    isSubmitDemand(){
      return this.form.status === 1 || this.form.status === 0;
    },
    //回退
    isRollback(){
      return this.form.status === 4;
    },
    //确认评审
    isConfirmReviewer(){
      return this.form.status === 4 || this.form.status === 5;
    },
    //是否可编辑
    isEditDemand(){
      return this.form.status === 0 || this.form.status === 1 || this.form.status === 2 || this.form.status === 3;
    },
    // 判断是否是新建
    isUpdata() {
      return this.form.id;
    },
    // 需求部分不可编辑
    isProjectDisabled() {
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
      }
      return false; // 默认可编辑
    },
    // 展示技术负责人部分的表单
    showReviewedForm() {
      return this.form.status != 0 && this.form.status != 1 && this.form.status != 2 && this.form.status != 3;
    },
    // 判断是否展示任务添加
    showTaskAdd() {
      const { status, username, reviewer } = this.form;
      if ( status !== 13 && status !== 1 && status > 3 && status < 8) {
        return true;
      }
      return false;
    },
    // 判断是否展示任务列表
    showTaskList() {
      return  this.tasks.length;
    },
  },
  methods: {
    upload (file, fileList) {
      const files = { 0: file.raw }// 取到File
      this.readExcel(files)
    },
    uploadDevTask(file, fileList){
      const files = { 0: file.raw }// 取到File
      this.readExcel(files,'dev')
    },
    uploadTestTask(file, fileList){
      const files = { 0: file.raw }// 取到File
      this.readExcel(files,'test')
    },
    readExcel (files,type= '') { // 表格导入
      if (files.length <= 0) { // 如果没有文件名
        return false
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传xls或者xlsx格式')
        return false
      }

      const fileReader = new FileReader()
      fileReader.onload = (files) => {
        try {
          const data = files.target.result
          const workbook = xlsx.read(data, {
            type: 'binary'
          })
          const wsname = workbook.SheetNames[0]// 取第一张表
          const ws = xlsx.utils.sheet_to_json(workbook.Sheets[wsname],{header:1,defval:''})// 生成json表格内容
          if(ws.length < 2){
            this.$notify({
              message:  "数据不能为空",
              type: "error",
            })
            return false;
          }
          // 重写数据
          this.$refs.uploadDev.value = ''
          this.$refs.uploadTest.value = ''
          if(type === 'dev'){
            this.handleDevData(ws);
          }
          if(type === 'test'){
            this.handleTestData(ws);
          }
          // return ws
        } catch (e) {
          console.log(e)
          return false
        }
      }
      fileReader.readAsBinaryString(files[0])
    },
    //开发任务
    handleDevData(data){
      if(data[0].length < 12){
        this.$notify({
          message:  "模版字段不完整，请检查",
          type: "error",
        })
        return false;
      }
      if(!data[0][0].includes('标题') || !data[0][1].includes('任务内容')  || !data[0][2].includes('数据量级要求') || !data[0][3].includes('响应时间要求') || !data[0][4].includes('并发量要求') || !data[0][5].includes('技术难度') || !data[0][6].includes('主域名') || !data[0][7].includes('涉及系统') || !data[0][8].includes('开发人员') || !data[0][9].includes('预估工时') || !data[0][10].includes('计划完成日期')) {
        this.$notify({
          message:  "模版不正确，请检查",
          type: "error",
        })
        return false;
      }
      let arr = [];
      let num = 0;
      data.forEach((item,index)=>{
        if(index > 0 && item[0]){
          if(!this.isValidFormat(item[10])){
            item[10] = '';
          }
          num++;
          arr.push({id: num ,name:item[0],taskContent:item[1],dataLevel:item[2],responseTime:item[3],concurrency:item[4],technicalDifficulty:item[5],domain:item[6],module:this.allSelect.NEWTEXTMODULES[item[7]]?item[7]:'' ,developerId: this.allUserList.DEVUSERUSER[item[8]]?this.allUserList.DEVUSERUSER[item[8]]:'',estimateWorkHour:item[9],planFinishDate:item[10],sign:num});
        }
      })
      if(arr.length < 1){
        this.$notify({
          message:  "导入数据为空，请检查",
          type: "error",
        })
        return false;
      }
      this.tasks = arr;
      this.showtasks = arr;
      this.testTasks.forEach((item,index)=>{
        if(!item.taskLists) {
          this.testTasks[index]['taskLists'] = [];
        }

      })

    },
    //测试任务
    handleTestData(data){
      if(data[0].length < 5){
        this.$notify({
          message:  "模版字段不完整，请检查",
          type: "error",
        })
        return false;
      }
      if(!data[0][0].includes('标题') || !data[0][1].includes('任务内容')  || !data[0][2].includes('测试人员') || !data[0][3].includes('预估工时') || !data[0][4].includes('计划完成日期')) {
        this.$notify({
          message:  "模版不正确，请检查",
          type: "error",
        })
        return false;
      }
      let arr = [];
      let num = 0;
      data.forEach((item,index)=>{
        if(index > 0 && item[0]){
          if(!this.isValidFormat(item[4])){
            item[4] = '';
          }
          num++;
          let signsArr = [];
          if(item[5]){
            let idString = item[5].toString(); //转字符串
            let signsIds = idString.split(','); //转数组
            signsIds.forEach((item)=>{
              //序号减1
              if(item && item >1) signsArr.push({sign:Number(item)-1});
            })
          }
          arr.push({id: num ,name:item[0],taskDetail:item[1],testerId:this.allUserList.DEVUSERUSER[item[2]]?this.allUserList.DEVUSERUSER[item[2]]:'',estimateWorkHour:item[3],planFinishDate:item[4],taskLists:signsArr});
        }
      })
      if(arr.length < 1){
        this.$notify({
          message:  "导入数据为空，请检查",
          type: "error",
        })
        return false;
      }
      this.testTasks = arr;
    },
    downloadDevTask(){
      let a = document.createElement('a') // 创建一个<a></a>标签
      a.href = `${window.location.origin}/devops/space/reporter/export?source_type=develops_models`;
      a.download = '开发任务导入模板.xlsx'         // 设置下载文件文件名
      a.style.display = 'none'           // 隐藏a标签
      document.body.appendChild(a)       // 将a标签追加到文档对象中
      a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove()                        // 用完就删除a标签
    },
    downloadTestTask(){
      let a = document.createElement('a') // 创建一个<a></a>标签
      a.href = 'https://tops2-static.ehsy.com/devops/test/export_test_model.xlsx'
      a.download = '测试任务导入模板.xlsx'         // 设置下载文件文件名
      a.style.display = 'none'           // 隐藏a标签
      document.body.appendChild(a)       // 将a标签追加到文档对象中
      a.click()                          // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove()                        // 用完就删除a标签
    },
    downloadFile(type){
      const token = getStorage('token', 'localStorage');
      let fileUrl = '';
      let fileName = '';
      if(type === 1){
        fileUrl = `${window.location.origin}/devops/space/reporter/export?source_type=develops_models`;
        fileName = '开发任务导入模板.xlsx';
      }
      if(type === 2){
       // fileUrl = `https://tops2-static.ehsy.com/devops/test/export_test_model.xlsx`;
        fileUrl = '/export_test_model.xlsx';
        fileName = '测试任务导入模板.xlsx';
      }
      const headers = {
        'token': token
      };
      axios.get(fileUrl, { responseType: "blob",headers: headers}).then(response => {
        const blob = new Blob([response.data]);
        const a = document.createElement("a");//创建a标签
        a.href = window.URL.createObjectURL(blob);// 创建下载的链接
        a.download = fileName;//下载文件名称
        a.style.display = "none";
        document.body.appendChild(a);//a标签追加元素到body内
        a.click();//模拟点击下载
        document.body.removeChild(a);// 下载完成移除元素
        window.URL.revokeObjectURL(a.href);// 释放掉blob对象
      }).catch(console.error);
    },
    handleCreateTaskClose(){
      this.dialogVisibleCreateTask = false;
    },
    copyTask(row){
      let maxNum = Math.max(...this.tasks.map(item => item.id));
      let id = maxNum + 1;
      const module = this.allSelect.NEWTEXTMODULES[row.module] ?  this.allSelect.NEWTEXTMODULES[row.module]: '';
      const domain = this.allSelect.NEWTEXTDOMAINS[row.domain]? this.allSelect.NEWTEXTDOMAINS[row.domain] : '';
      this.formTaskInfo = {...row,openType:'copy',module,domain,id:id,sign:id};
      this.dialogVisibleCreateTask = true;
    },
    editTask(row){
      const module = this.allSelect.NEWTEXTMODULES[row.module] ?  this.allSelect.NEWTEXTMODULES[row.module]: '';
      const domain = this.allSelect.NEWTEXTDOMAINS[row.domain]? this.allSelect.NEWTEXTDOMAINS[row.domain] : '';
      this.formTaskInfo = {...row,module,domain};
      this.dialogVisibleCreateTask = true;
    },
    addTask(){
      this.formTaskInfo = {};
     this.dialogVisibleCreateTask = true;
    },
    deleteTask(row){
      this.$confirm("确认删除该任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.tasks = this.tasks.filter(function (item) {
          return item.id !== row.id;
        });
        this.showtasks = this.showtasks.filter(function (item) {
          return item.id !== row.id;
        });
        // let num = 0;
        // this.tasks.forEach((item,index)=>{
        //     num++;
        //     this.tasks[index].id = num;
        // })
        // let num2 = 0;
        // this.tasks.forEach((item2,index2)=>{
        //     num2++;
        //     this.tasks[index2].id = num2;
        // })

        //删除关联测试的开发任务
        this.delTaskToTest(row);
      })

    },
    deleteTestTask(row){
      this.$confirm("确认删除该测试任务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.testTasks = this.testTasks.filter(function (item) {
          return item.id !== row.id;
        });
        // let num = 0;
        // this.testTasks.forEach((item,index)=>{
        //   num++;
        //   this.testTasks[index].id = num;
        // })
      })

    },
    handleCreateTestTaskClose(){
      this.dialogVisibleCreateTestTask = false;
    },
    handleChooseTaskClose(){
      this.dialogVisibleChooseTask = false;
    },
    copyTestTask(row){
      let maxNum = Math.max(...this.tasks.map(item => item.id));
      let id = maxNum + 1;
      this.formTestTaskInfo = {...row,openType:'copy',id:id,sign:id};
      this.dialogVisibleCreateTestTask = true;
    },
    editTestTask(row){
      let taskLists = [];
      if(row.taskLists){
        taskLists = row.taskLists;
      }
      this.formTestTaskInfo = {...row,taskLists:taskLists};
      this.dialogVisibleCreateTestTask = true;
    },
    addTestTask(){
      this.formTestTaskInfo = {};
      this.dialogVisibleCreateTestTask = true;
    },
    async changeTask(task){
      if(task.openType === 'create' || task.openType === 'copy'){
        let num = this.tasks.length + 1;
        this.tasks.push({id: num ,name:task.name,taskContent:task.taskContent,dataLevel:task.dataLevel,responseTime:task.responseTime,concurrency:task.concurrency,technicalDifficulty:task.technicalDifficulty,domain:task.domain,module:task.module,developerId: task.developerId,estimateWorkHour:task.estimateWorkHour,planFinishDate:task.planFinishDate,sign:num});
      }
      if(task.openType === 'save'){
        this.tasks.forEach((item,index)=>{
          if(item.id == task.id){
            this.tasks[index].name = task.name;
            this.tasks[index].taskContent = task.taskContent;
            this.tasks[index].dataLevel = task.dataLevel;
            this.tasks[index].responseTime = task.responseTime;
            this.tasks[index].concurrency = task.concurrency;
            this.tasks[index].technicalDifficulty = task.technicalDifficulty;
            this.tasks[index].domain = task.domain;
            this.tasks[index].module = task.module;
            this.tasks[index].developerId = task.developerId;
            this.tasks[index].estimateWorkHour = task.estimateWorkHour;
            this.tasks[index].planFinishDate = task.planFinishDate;
          }
        })
      }
    },
    async changeTestTask(testTask){
      if(testTask.openType === 'create' || testTask.openType === 'copy'){
        let num = this.testTasks.length + 1;
        this.testTasks.push({id: num ,name:testTask.name,taskDetail:testTask.taskDetail,testerId:testTask.testerId,estimateWorkHour:testTask.estimateWorkHour,planFinishDate:testTask.planFinishDate,taskLists:[]});
      }
      if(testTask.openType === 'save'){
        this.testTasks.forEach((item,index)=>{
          if(item.id == testTask.id){
            this.testTasks[index].name = testTask.name;
            this.testTasks[index].taskDetail = testTask.taskDetail;
            this.testTasks[index].testerId = testTask.testerId;
            this.testTasks[index].estimateWorkHour = testTask.estimateWorkHour;
            this.testTasks[index].planFinishDate = testTask.planFinishDate;
          }
        })
      }

    },
    showChoosTask(row){
      this.showtasks = this.tasks;
      this.checkedTestInfo = row;
      this.dialogVisibleChooseTask = true;
    },
    getChooseTask(choose){
      let addData = choose.selectData;
      let id = choose.id;
      this.testTasks.forEach((item,index)=>{
        if(item.id === id){
          this.testTasks[index]['taskLists'] = addData;
        }
      })
    },
    changeChoose(form){
      let devTaskName = form.devTaskName;
      let module = form.module.toString();
      let developerId = form.developerId;
      let arr = [];
      this.tasks.forEach((item,index)=>{
        let itemModule =  this.allSelect.NEWTEXTMODULES[item.module] ?  this.allSelect.NEWTEXTMODULES[item.module]: '';
        //搜索全部
        if(devTaskName && module && developerId){
          if(item.name.includes(devTaskName) && module.includes(itemModule) &&  item.developerId == developerId){
            arr.push(item)
          }
        }else if(devTaskName && module){
          if(item.name.includes(devTaskName) && module.includes(itemModule)){
            arr.push(item)
          }
        }else if(devTaskName && developerId){
          if(item.name.includes(devTaskName)  &&  item.developerId == developerId){
            arr.push(item)
          }
        }else if(module && developerId){
          if(module.includes(itemModule) &&  item.developerId == developerId){
            arr.push(item)
          }
        }else if(devTaskName){
          if(item.name.includes(devTaskName)){
            arr.push(item)
          }
        }else if(module){
          if(module.includes(itemModule)){
            arr.push(item)
          }
        }else if(developerId){
          if(item.developerId == developerId){
            arr.push(item)
          }
        }else{
          arr.push(item)
        }
      })
     this.showtasks = arr;
    },
    isValidFormat(vtime) {
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      return regex.test(vtime);
    },
    getDevUserList(){
      getDevOpsSpaceAllUserListApi({userType:3}).then((res)=>{
        let arrEn = [];
        let arrIds = [];
        res.data.forEach((item)=>{
          arrEn[item.devops_name] = item.user_name;
          arrIds[item.devops_name] = item.id;
        })
        this.allDevUser.UserEn = arrEn;
        this.allDevUser.UserIds = arrIds;
      })
    },
    getProjectList(systemId){
      getDevOpsSpaceFindProjectNameApi({isEffective:true,systemId: systemId}).then(res=>{
        if(res.data){
          this.projectList = res.data;
        }
      })
    },
    async getMeetList(id){
      await getDevOpsSpaceMeetListApi({demandId: id}).then((res)=>{
        this.meetList = res.data;
      });
    },
    async change(){
      await this.getMeetList(this.form.id);

    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:2,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    // 变更需求状态
    onChangePStatus(){
      this.$refs["pStatusForm"].validate(async (valid) => {
        if (valid) {
          this.queryChangePStatus()
        }
      })
    },
    onChangePUat(){
      this.$refs["pUatForm"].validate(async (valid) => {
        if (valid) {
          this.onSubmitDemand(4);
          //console.log(33333333)
          //this.queryChangePStatus()
        }
      })
    },
    onChangePro(){
      this.$refs["proForm"].validate(async (valid) => {
        if (valid) {
          this.onSubmitDemand(7);
          //console.log(33333333)
          //this.queryChangePStatus()
        }
      })
    },
    async queryChangePStatus(isRestart = false){
      this.$set(this.loading, 'submitReset', true)
      if(this.pStatusForm.status == '13'){
        if(this.form.status < 6){
          this.$notify({
            message:  "开发阶段中/测试阶段中/UAT阶段中才允许暂停",
            type: "error",
          })
          return false;
        }
      }
      try {
        let params =  { ...this.pStatusForm, id:this.form.id, status:Number(this.pStatusForm.status), isRestart:isRestart}
        const ret = await postDevOpsSpaceUserPmEditStatusApi(params);
        if(ret.status === 'success'){
          this.dialogVisiblePStatus = false;
          this.$notify({
            message: ret.message || "变更成功",
            type: "success",
          })
          this.hideDialogVisible()
        }else{
          this.$notify({
            message: ret.message || "变更失败",
            type: "error",
          })
        }
        this.loading.submitReset = false;
      } catch (error) {
        this.$notify({
          message: error || "变更失败",
          type: "error",
        })
        this.loading.submitReset = false;
      }
    },
    // 回退
    onRollback(){
      this.$confirm('此操作将回退到上一步, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        type: 'warning'
      }).then(async () => {
        try {
          this.$set(this.loading, 'submitRollBack', true)
          const ret = await postDevOpsSpaceUserPmEditStatusApi({id:this.form.id,isRollBack: true})
          if (ret.status === 'success') {
            this.$notify({
              message: '回退成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()
            }, 500)
          } else {
            this.$notify({
              message: ret.message || "回退失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.submitRollBack = false;
        }
      })
    },
    changeProjectSystem(val) {

      let arr = {};
      getDevOpsSpaceAllUserListApi({userType: 5,project_system_id:val}).then((res)=>{
        res.data.forEach((item,index)=>{
          arr[item.id] = item.user_name;
        });
        this.reviewerSelect = arr;
      });


      this.getProjectList(val);

    },
    changeStep(step) {
      this.step = step;
      this.changeProjectSystem(this.form.systemId);
    },
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:20px;background:#7F7F7F;color:#fff;font-size:12px;"
    },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0 || columnIndex == 1){
        return "font-size: 12px;font-weight: bold;padding:6px 0;";
      }
      return "font-size: 12px;padding:6px 0;";
    },
    // 获取需求详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceFindOneDemandApi({id:id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          demanderId: info.demanderId?info.demanderId.toString(): '',
          systemId: info.systemId?info.systemId.toString():'',
          pmId: info.pm.id?info.pm.id.toString():'',
          reviewerId: info.reviewer.id ? info.reviewer.id.toString() : '',
          creator: info.creator,
        };
        this.isUserPm =( this.form.username === info.user_pm);
        //this.changeProjectSystem(info.systemId);
        this.reviewerSelect = this.allUserList.ALLUSERTYPE1;
        this.recordList = info.update_text;
        this.getProjectList(this.form.systemId);
        this.queryTaskList(id);
        this.queryTestTaskList(id);
        if (info.details) { this.showDetails = true }
        if(info.status === 0 || info.status === 1){
          this.rules.reviewerId = false;
          this.rules.prdLink = false;
          this.rules.planFinishDate = false;
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }
    },
    onApplyRelease(){
      this.dialogVisibleApplyRelease = true;
    },
    async onApplySkipRelease(){
      this.$refs["pSkipForm"].validate(async (valid) => {
        if (valid) {
          this.$confirm("此操作将跳过发布, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            try{
              this.$set(this.loading, 'skipRelease', true)
              const res = await getDevOpsSpaceDemandSkipApi({demandId:this.form.id,skipReason:this.pSkipForm.skipReason});
              if(res.status === 'success'){
                this.$notify({
                  message: '提交成功',
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()

                }, 500)
                this.loading.skipRelease =false;
              }else{
                this.$notify({
                  message: res.message || "提交失败",
                  type: "error",
                })
                this.loading.skipRelease =false;
              }
            }catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
              this.loading.skipRelease =false;
            }finally {
              this.loading.skipRelease =false;
            }

          });
        }
      })
    },
    onUpdateTime(){
      this.$refs["updateTimeForm"].validate(async (valid) => {
        if (valid) {
          try {
            let currentTime = Date.parse(this.getDate());
            let planFinishDate = Date.parse(this.updateTimeForm.planFinishDate);
            if(currentTime > planFinishDate){
              this.$notify({
                message: "修改日期要大于等于当前日期",
                type: "error",
              })
              return false;
            }
            if(this.updateTimeForm.planFinishDate == this.form.planFinishDate){
              this.$notify({
                message: "修改日期不能和原日期一致",
                type: "error",
              })
              return false;
            }
            this.$set(this.loading, 'updateTimeLoad', true);
            const {
              id = '',
            } = this.form;
            const update_date_reason = { demand_id: id, planFinishDate:this.updateTimeForm.planFinishDate ,update_date_reason:this.updateTimeForm.update_date_reason,preDate:this.form.planFinishDate,operatorDateTime: this.getNowDate()};
            const param = { demand_id: id, planFinishDate:this.updateTimeForm.planFinishDate ,updateDateText:update_date_reason,preDate:this.form.planFinishDate,};
            const ret =  await postDevOpsSpaceUpdatePlanDateApi(param);
            if (ret.status === 'success') {
              this.dialogVisibleUpdatePlanTime = false;
              await this.init(id);
              this.$notify({
                message: ret.message || "成功",
                type: "success",
              })
            } else {
              this.$notify({
                message: ret.message || "失败",
                type: "error",
              })
            }
          } catch (error) {
            this.$notify({
              message: error || "网络错误",
              type: "error",
            })
          } finally {
            this.loading.updateTimeLoad = false;
          }
        }

      })
    },
    // 添加任务
    onAddTask(type, row) {
      const {status,techDesc,techDocLink,id,name,pmId,pm,prdLink} = this.form;
      if (type === 'add') {
        this.formTaskInfo = { status, techDesc,techDocLink: this.formatLink(techDocLink), id,name, pmId, pm, prdLink: this.formatLink(prdLink),taskInfo: { pid: id, name } }
      }
      if (type === 'copy') {
        this.formTaskInfo = { status, techDesc,techDocLink: this.formatLink(techDocLink), id,name, pmId, pm, prdLink: this.formatLink(prdLink),taskInfo: { pid: id, name } }
        this.formTaskInfo.openType = 'copy';
        this.formTaskInfo.taskId = row.taskId;
      }
      this.dialogVisibleTask = true;
    },
    // 添加测试任务
    onAddTestTask(type, row) {
      const {techDocLink,id,name,pmId,pm,prdLink} = this.form;
      if (type === 'add') {
        this.formTestTaskInfo = {
          ...this.form,
          prdLink: this.formatLink(prdLink),
          techDocLink: this.formatLink(techDocLink),
          taskInfo: {
            ...row,
            pid: id,
          }
        }
      }
      if (type === 'copy') {
        this.formTestTaskInfo = {
          ...this.form,
          prdLink: this.formatLink(prdLink),
          techDocLink: this.formatLink(techDocLink),
          taskInfo: {
            ...row,
            pid: id,
            openType: 'copy',
          }
        }
      }


      this.dialogVisibleTestTask = true;
    },
    // 添加会议记录
    onAddMeet(type, row) {
      this.dialogVisibleMeet = true;
    },
    // 链接判断
    formatLink(val){
      if(!val) return '';
      return val.startsWith('http') ? val :`http://${val}`
    },
    // 提交
    async onSubmit(close = true) {
      let params = {};
      params.demandId = this.formInfo.id;
      params.demandstatus = this.formInfo.status;
      if(this.tasks.length < 1){
        this.$notify({
          message: "开发任务不能为空",
          type: "error",
        })
        return false;
      }
  /*    if(this.testTasks.length < 1){
        this.$notify({
          message: "测试任务不能为空",
          type: "error",
        })
        return false;
      }*/
      let developList = [];
      let overTimeTask = false;
      let noTaskDate = false;
      this.tasks.forEach((item,index)=>{
        if(item.estimateWorkHour > 30){
          overTimeTask = true;
        }
        if(!this.isValidFormat(item.planFinishDate)){
          noTaskDate = true;
        }
        const module = this.allSelect.NEWTEXTMODULES[item.module] ?  this.allSelect.NEWTEXTMODULES[item.module]: '';
        const domain = this.allSelect.NEWTEXTDOMAINS[item.domain]? this.allSelect.NEWTEXTDOMAINS[item.domain] : '';
        const developerId = item.developerId ? Number(item.developerId) : null;
        developList.push({id:item.sign,name:item.name,data_level:item.dataLevel,task_detail:item.taskContent,response_time:item.responseTime,concurrency:item.concurrency,technical_difficulty:item.technicalDifficulty,domain:domain,module:module,developer_id:developerId,estimate_work_hour:item.estimateWorkHour,plan_finish_time:item.planFinishDate})
      })
      let testList = [];
      let devUser = this.invertDevUser(this.allUserList.DEVUSERUSER);
      let flag = false;
      let overTimeTestTask = false;
      let noTestTaskDate = false;
      this.testTasks.forEach((v,k)=>{
        if(v.estimateWorkHour > 30){
          overTimeTestTask = true;
        }
        if(!this.isValidFormat(v.planFinishDate)){
          noTestTaskDate = true;
        }
        let taskIds = [];
        if(v.taskLists.length > 0){
          let newTaskLists = [];
          v.taskLists.forEach((v2,k2)=>{
            //重新组装校验关联任务
            for(let i in this.tasks){
              if(this.tasks[i]['sign'] === v2.sign){
                newTaskLists.push(v2);
                taskIds.push(v2.sign)
              }
            }
            //taskIds.push(v2.sign)
          })
          this.testTasks[k]['taskLists'] = newTaskLists;
        }/*else{
          flag = true;
        }*/
        if(!this.testTasks[k]['taskLists'] ||  this.testTasks[k]['taskLists'].length === 0){
          flag = true;
        }
        let testerName = devUser[v.testerId] ? devUser[v.testerId] : '';
        testList.push({id:v.id,name:v.name,task_detail:v.taskDetail,tester_id:Number(v.testerId),plan_finish_time: v.planFinishDate,estimate_work_hour:v.estimateWorkHour,tester_name:testerName,dev_task_ids:taskIds})
      })
      if(flag){
        this.$notify({
          message: "测试任务未关联开发任务",
          type: "error",
        })
        return false;
      }
      if(overTimeTask){
        this.$notify({
          message: "开发任务工时不正确,请合理填写",
          type: "error",
        })
        return false;
      }
      if(overTimeTestTask){
        this.$notify({
          message: "测试任务工时不正确,请合理填写",
          type: "error",
        })
        return false;
      }
      if(noTaskDate){
        this.$notify({
          message: "开发任务计划完成日期格式不正确",
          type: "error",
        })
        return false;
      }
      if(noTestTaskDate){
        this.$notify({
          message: "测试任务计划完成日期格式不正确,请合理填写",
          type: "error",
        })
        return false;
      }
      params.developList = developList;
      params.testList = testList;
      try {
        this.$set(this.loading, 'submit', true)
        await postDevOpsSpaceBatchCreateTaskApi(params).then((res)=>{
          if(res.status === 'success'){
            this.$notify({
              message: res.message || "成功",
              type: "success",
            })
            this.handleClose();
          }else{
            this.$notify({
              message: res.message || "失败",
              type: "error",
            })
          }
        })
      } catch (error) {
        this.$notify({
          message: "失败",
          type: "error",
        })
        this.loading.submit = false;
      }finally {
        this.loading.submit = false;
      }

      /*if(this.form.reviewerId){
        this.form.reviewerId = this.form.reviewerId.toString();
      }
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });*/
    },
    invertDevUser(original) {
      return Object.keys(original).reduce((inverted, key) => {
        inverted[original[key]] = key;
        return inverted;
      }, {});
  },
    //删除开发任务，去删除测试任务关联的开发任务
    delTaskToTest(row){
      this.testTasks.forEach((item,index)=>{
        let taskLists = [];
        item.taskLists.forEach((v,k)=>{
          if(v.sign != row.sign){
            taskLists.push(v);
          }
        })
        this.testTasks[index].taskLists = taskLists;
      })
    },
    //确认评审
    async onSubmitConfirmReviewer(){
      if(this.tasks.length < 1){
        this.$notify({
          message: "请添加开发任务和测试任务!",
          type: "error",
        })
        return false;
      }
      const {
        name = "",
        projectId = "",
        systemId = '',
        demanderId = '',
        pmId = [],
        priority = "",
        planFinishDate = "",
        demandDesc = "",
        reviewerId = '',
        prdLink = '',
        expectFinishDate = '',
        techDocLink = '',
        techDesc = '',
        p_status = '',
        id = '',
        tag = '',
      } = this.form;
      const param = { name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc,tag};
      this.$set(this.loading, 'submitConfirmReviewer', true);
      await postDevOpsSpaceEditDemandApi({...param, demand_id: this.form.id || "" }).then((ret)=>{
        if(ret.status === 'success'){
          this.$set(this.loading, 'submitConfirmReviewer', false);
          this.onSubmitDemand(3)
        }else{
          this.$notify({
            message: ret.message || "提交失败",
            type: "error",
          })
          this.$set(this.loading, 'submitConfirmReviewer', false);
        }
      })
    },
    //提交需求评审
    async onSubmitDemand(type){
      /* if(this.form.reviewerId){
         this.form.reviewerId = this.form.reviewerId.toString();
       }*//*
      this.rules.reviewerId = true;
      this.rules.prdLink = true;*/
      if(type === 1 || type === 2){
        if(!this.form.reviewerId){
          this.$notify({
            message: "技术负责人必填",
            type: "error",
          })
          return false;
        }
        if(!this.form.prdLink){
          this.$notify({
            message: "PRD必填",
            type: "error",
          })
          return false;
        }
      }
      let content = '此操作将进行到下一步, 是否继续?';
      if(type === 1){
        content = '请确认提交需求评审？';
      }
      if(type === 2){
        content = '请确认提交技术评审？';
      }
      if(!this.form.demandDesc){
        this.form.demandDesc = '1';
      }

      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.$confirm(content, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            type: 'warning'
          }).then(async () => {
            this.form.reviewerId = this.form.reviewerId.toString();
            try {
              if(type === 2)  this.$set(this.loading, 'submitReviewed', true);
              if(type === 1)  this.$set(this.loading, 'submitDemand', true);
              if(type === 6)  this.$set(this.loading, 'submitCancel', true);
              if(type === 7)  this.$set(this.loading, 'submitComplete', true);
              if(type === 4)  this.$set(this.loading, 'submitUat', true);
              if(type === 3)  this.$set(this.loading, 'submitConfirmReviewer', true);


              let params =  {id: this.form.id,type:type};
              if(type === 2){
                await this.onSubmit();
              }
              if(type === 4){
                params = {...params,...this.pUatForm,}
              }
              if(type === 7){
                params = {...params,...this.proForm,}
              }
              await postDevOpsSpaceSubmitDemandApi(params).then((result)=>{
                if(result.status === 'success'){
                  this.$notify({
                    message: result.message || '提交成功',
                    type: "success",
                  })
                  setTimeout(() => {
                    this.handleClose()
                  }, 500)
                }else{
                  this.$notify({
                    message: result.message || "提交失败",
                    type: "error",
                  })
                  this.handleClose()
                }

                this.loading.submitReviewed = false;
                this.loading.submitDemand = false;
                this.loading.submitCancel = false;
                this.loading.submitComplete = false;
                this.loading.submitUat = false;
                this.loading.submitConfirmReviewer = false;
              });
            } catch (error) {
              this.$notify({
                message: error || "网络错误",
                type: "error",
              })
            } finally {
              this.loading.submitReviewed = false;
              this.loading.submitDemand = false;
              this.loading.submitCancel = false;
              this.loading.submitComplete = false;
              this.loading.submitUat = false;
              this.loading.submitConfirmReviewer = false;
            }
          })
        }
      })
    },
    // 调用需求提交接口
    async moduleSubmit(close = true){
      try {
        close && this.$set(this.loading, 'submit', true)
        const {
          name = "",
          projectId = "",
          systemId = '',
          demanderId = '',
          pmId = [],
          priority = "",
          planFinishDate = "",
          demandDesc = "",
          reviewerId = '',
          prdLink = '',
          expectFinishDate = '',
          p_category = [],
          techDocLink = '',
          techDesc = '',
          p_status = '',
          id = '',
          tag = '',
        } = this.form;
        const param = { name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc,tag};
        // id 存在 更新 不存在 创建
        const ret = this.isUpdata ? await postDevOpsSpaceEditDemandApi({ ...param, demand_id: this.form.id || "" }) : await postDevOpsSpaceCreateDemandApi(param);
        if (ret.status === 'success') {
          if (close) {
            this.$notify({
              message: '提交成功',
              type: "success",
            })
            setTimeout(() => {
              this.handleClose()

            }, 500)
          }
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    changTechDocLink(val){
      this.saveSubmit();
    },
    changTechDesc(){
      this.saveSubmit();
    },
    async saveSubmit(){
      const {
        name = "",
        projectId = "",
        systemId = '',
        demanderId = '',
        pmId = [],
        priority = "",
        planFinishDate = "",
        demandDesc = "",
        reviewerId = '',
        prdLink = '',
        expectFinishDate = '',
        techDocLink = '',
        techDesc = '',
        p_status = '',
        id = '',
      } = this.form;
      const param = { name, demandDesc,projectId, id: id, demanderId:Number(demanderId) ,pmId: Number(pmId), systemId:Number(systemId), project_status: p_status, priority, reviewerId:Number(reviewerId),planFinishDate, expectFinishDate, prdLink: this.formatLink(prdLink), techDocLink: this.formatLink(techDocLink),techDesc:techDesc};
      await postDevOpsSpaceEditDemandApi({...param, demand_id: this.form.id || "" });
    },
    // 修复 input 框输入 乱聚焦到富文本的问题
    focusLinkFn(refName) {
      setTimeout(() => {
        this.$refs[refName].focus()
      })
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    // 打开新的模块
    linkToModel(row, type, back = '') {
      let newRow = {
        ...this.form,
        ...row,
      }
      /*if(type === 'task'){
        newRow.pid = this.form.id;
        newRow.id = row.taskId;
      }*/
      this.showDialogVisible(type, newRow, back)
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.demandDesc = val;
    },
    // 修改富文本内容
    changeUatContent(val) {
      this.pUatForm.uatDetail = val;
    },
    changeProContent(val) {
      this.proForm.proDetail = val;
    },
    // 修改富文本内容
    changeSkipContent(val) {
      this.pSkipForm.skipReason = val;
    },
    changeUpdateDateReasonContent(val){
      this.updateTimeForm.update_date_reason = val;
    },
    // 删除任务
    onDeleteTask(row) {
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'task' + row.taskId, true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: row.taskId,
          });
          if (res.status === "success") {
            this.queryTaskList(this.form.id)
          } else {
            this.$notify({
              message: res?.data?.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['task' + row.taskId] = false;
        }
      });
    },
    // 删除测试任务
    onDeleteTestTask(row) {
      this.$confirm("此操作将删除该测试任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'test' + row.id, true)
        try {
          const res = await postDevOpsSpaceDeleteTestTaskApi({
            id: row.id,
          });
          if (res.status === "success") {
            this.queryTestTaskList(this.form.id)
          } else {
            this.$notify({
              message: res.message || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "数据错误",
            type: "error",
          })
        } finally {
          this.loading['test' + row.id] = false;
        }
      });
    },
    handleApplyReleaseClose(){
      this.dialogVisibleApplyRelease = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
    },
    // 关闭任务弹窗
    handleTaskClose(info = '') {
      this.dialogVisibleTask = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
      this.getMeetList(this.form.id);
    },
    handleTestTaskClose(){
      this.dialogVisibleTestTask = false;
      this.init(this.form.id);
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
      this.getMeetList(this.form.id);
    },
    // 关闭任务弹窗
    handleMeetClose() {
      this.dialogVisibleMeet = false;
      this.getMeetList(this.form.id);
      this.init(this.form.id)
      this.queryTaskList(this.form.id)
      this.queryTestTaskList(this.form.id)
      this.getHistoryList();
    },
    // 任务列表
    async queryTaskList(id) {
      try {
        const res = await getDevOpsSpaceProducerListApi({ demandId: id });
        this.tasks = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    // 获取测试任务列表
    async queryTestTaskList(id) {
      try {
        const res = await getDevOpsSpaceDemandTestTaskApi({ demandId: id });
        this.testTasks = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      let h = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
      let m = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
      let s = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
      return year + "-" + cmonth + "-" + cday + " " + h + ":" + m + ":" + s;
    },
    getDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
  }
};
</script>
<style lang="scss">
.import_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .table_text_click_new {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
}

.popperDom {
  max-width: 240px;
}
.meet-line{
  height: 1px;
  border-top: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
}
.meet-line label{
  position: relative;
  top: -8px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  color: #606266;
}
.down-xsl{
  color: #409EFF;
  cursor: pointer;
}
</style>
